var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvalanche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Avalance_icon",
    "data-name": "Avalance icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 32,
    height: 32,
    rx: 12,
    transform: "translate(0 32) rotate(-90)",
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(7 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M.108,15.234,8.472.4A.786.786,0,0,1,9.836.4l2.357,4.077a2.281,2.281,0,0,1,.015,2.256l-4.7,8.4a2.461,2.461,0,0,1-2.147,1.258H.778a.77.77,0,0,1-.67-1.148Zm13.876-5.153-2.931,5.076a.816.816,0,0,0,.707,1.224h5.861a.816.816,0,0,0,.707-1.224L15.4,10.082a.816.816,0,0,0-1.414,0Z",
    transform: "translate(-0.007 -0.003)",
    fill: "#e84142"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.af17571f5d1fc3b8cdb7ee1bf6276295.svg";
export { ForwardRef as ReactComponent };